import { log } from "./logger";

/**
 * Downloads file for user, via creating temporary link and clicking it
 * @param file link or actual file
 * @param fileName name of file
 */
export function downloadFile(file: string, fileName?: string) {
	try {
		const a = document.createElement("a");
		a.href = file;
		if (fileName) a.download = fileName;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	} catch (e) {
		log(e, "error");
	}
}
